import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import '@/styles/FallBackPage.css';
import { useAuth } from '@/AuthContext'; // Import useAuth
const WhiteCircle = ({ children }) => (_jsx("div", Object.assign({ className: "white-circle" }, { children: children })));
const FallBackForm = () => {
    const { initiateLogin } = useAuth(); // Get initiateLogin from context
    const handleLogin = () => {
        initiateLogin(); // Trigger the login process
    };
    return (_jsxs(WhiteCircle, { children: [_jsx("p", Object.assign({ className: "welcome-message" }, { children: "Please log in to access the chat." })), _jsx("button", Object.assign({ className: "sidebar-button", onClick: handleLogin }, { children: "LOG IN" })), ' '] }));
};
export default FallBackForm;
